import { useState, useCallback } from "react";

export function useHighlight(duration = 1500) {
  const [highlight, setHighlight] = useState(false);

  const triggerHighlight = useCallback(() => {
    setHighlight(true);
    setTimeout(() => setHighlight(false), duration);
  }, [duration]);

  return { highlight, triggerHighlight };
}
